/* Local dependencies */
import { ModalActionInterface, ModalActionTypes } from "./action";

export interface ModalState {
  isAuthModalOpen: boolean
  isUserModalOpen: boolean
  modalType: string
}

export const initialModalState: ModalState = {
  isAuthModalOpen: false,
  isUserModalOpen: false,
  modalType: 'mainContent'
};

export default function modalReducer(state = initialModalState, action: ModalActionInterface) {
  switch (action.type) {
    case ModalActionTypes.IS_AUTH_OPEN:
      return {
        ...state,
        isAuthModalOpen: action.payload
      }

    case ModalActionTypes.IS_USER_OPEN:
      return {
        ...state,
        isUserModalOpen: action.payload
      }

    case ModalActionTypes.MODAL_TYPE:
      return {
        ...state,
        modalType: action.payload
      }

    default:
      return state;
  }
}
